import { useState, type FormEvent } from 'react';
import { signIn } from '../auth-client';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError('');
    const result = await signIn.email({ email, password });
    setBusy(false);
    // Never say which half was wrong — that would confirm whether an account exists.
    if (result.error) setError('Wrong email or password.');
  }

  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-[22rem] flex-col justify-center px-6 py-10">
      <div className="flex items-center gap-2.5">
        <span
          aria-hidden
          className="grid size-8 place-items-center rounded-[6px] bg-brand text-[13px] font-bold text-brand-ink"
        >
          tp
        </span>
        <span className="text-[17px] font-semibold tracking-[-0.015em]">taskpilot</span>
      </div>
      <p className="mt-2 text-[13px] text-ink-2">
        The console for agent runs that happen with nobody watching.
      </p>

      <form
        onSubmit={submit}
        className="mt-6 flex flex-col gap-3 rounded-[7px] border border-rule bg-panel p-4 shadow-[var(--shadow-panel)]"
      >
        <label className="flex flex-col gap-1.5">
          <span className="label-caps">Email</span>
          <Input
            type="email"
            required
            autoComplete="username"
            className="h-9"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>
        <label className="flex flex-col gap-1.5">
          <span className="label-caps">Password</span>
          <Input
            type="password"
            required
            autoComplete="current-password"
            className="h-9"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        {error && (
          <p
            role="alert"
            className="rounded-[5px] border border-bad/30 bg-bad-soft px-2.5 py-1.5 text-[12px] text-bad"
          >
            {error}
          </p>
        )}
        <Button type="submit" size="lg" disabled={busy} className="mt-1 w-full">
          {busy ? 'Signing in…' : 'Sign in'}
        </Button>
      </form>

      <p className="mt-4 text-[12px] text-ink-3">
        Accounts are created by an administrator — there is no self-service sign-up.
      </p>
    </main>
  );
}
